import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Box } from '@gemini/core';
import { useSerpTranslation } from '@search/core/hooks/useI18n';
export const ZeroResultsTitle = () => {
    const { t } = useSerpTranslation();
    const labelZeroResults = t('list.zero_results.label');
    const descriptionZeroResults = t('list.zero_results.cta_description');
    return (_jsxs(_Fragment, { children: [_jsx(Box, { as: "p", typography: "typography.body.16.regular", children: labelZeroResults }), _jsx(Box, { as: "p", typography: "typography.body.14.regular", children: descriptionZeroResults })] }));
};
